import React from 'react';
import { X } from 'lucide-react';

const toneStyles = {
  error: 'bg-rose-50 text-rose-800 border-rose-200',
  warning: 'bg-amber-50 text-amber-800 border-amber-200',
  success: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  info: 'bg-blue-50 text-blue-800 border-blue-200'
};

const TopAlert = ({ message, tone = 'info', onClose }) => {
  if (!message) return null;

  return (
    <div className={`w-full border rounded-lg px-4 py-3 flex items-start justify-between ${toneStyles[tone]}`} role="alert">
      <div className="text-sm font-medium pr-4">{message}</div>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          className="inline-flex items-center justify-center rounded-md p-1 hover:bg-white/60"
          aria-label="Dismiss alert"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default TopAlert;
